import { createContext } from 'react';
import noop from 'lodash/noop';

const KeenContext = createContext({
  loading: false,
  updateContextValues: (valuesToUpdate = {}, callback = noop) => {},
});

export default KeenContext;
